<template>
    <div class="flex max-w-30rem w-full">
        <form @submit.prevent="handleSubmit(!v$.$invalid)" class="flex flex-column w-full p-fluid">
            <!--LOGIN-->
            <div class="field mt-2 mb-2">
                <span class="text-color-secondary">{{ fields[lang].login }}:</span>
                <div class="p-float-label p-input-icon-right">
                    <IconField iconPosition="right" class="w-full">
                        <InputText id="login" v-model="v$.login.$model" aria-describedby="login-error" class="pl-2"
                            :class="{'p-invalid':v$.login.$invalid && submitted, 'p-inputtext-lg': true, 'mt-2': true, 'mb-2': true, 'w-full': true, 'border-2': true, 'border-round-lg': true}"/>
                        <InputIcon class="pi pi-at"/>
                    </IconField>
                </div>
                <span v-if="v$.login.$error && submitted">
                    <span id="email-error" v-for="(error, index) of v$.login.$errors" :key="index">
                        <small class="p-error">{{error.$message}}</small>
                    </span>
                </span>
                <small v-else-if="(v$.login.$invalid && submitted) || v$.login.$pending.$response" class="p-error">{{v$.login.required.$message.replace('Value', 'login')}}</small>
            </div>

            <!--PASSWORD-->
            <div class="field mt-2 mb-2">
                <span class="text-color-secondary">{{ fields[lang].password }}:</span>
                <div class="p-float-label">
                    <Password id="password" v-model="v$.password.$model" toggleMask :feedback="false"
                    :class="{'p-invalid':v$.password.$invalid && submitted, 'p-inputtext-lg': true, 'mt-2': true, 'mb-2': true, 'w-full': true, 'border-2': true, 'border-round-lg': true, 'surface-border': true}" />
                </div>
                <small v-if="(v$.password.$invalid && submitted) || v$.password.$pending.$response" class="p-error">{{v$.password.required.$message.replace('Value', 'Password')}}</small>
            </div>

            <Button type="submit" :label="buttons[lang].login" class="mt-2 w-full border-round-lg" :loading="isLoading" :disabled="v$.$invalid" severity="info" size="large" />
        </form>
    </div>
</template>


<script>
import Connect from '@/assets/js/connect.js'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { mapActions } from "vuex"

export default {
    props: ['redirect_url'],
    data() {
        return {
            fields:  {
                en:{
                    login : "Email",
                    password: "Password",
                    or: "or",
                },
                ru:{
                    login : "Email",
                    password: "Пароль",
                    or: "или",
                }                 
            },
            buttons:  {
                en:{
                    login : "Login",
                    registation: "Registration",
                    forgot_password: "Forgot password",
                },
                ru:{
                    login : "Войти",
                    registation: "Регистрация",
                    forgot_password: "Забыл пароль",
                }
                 
            }, 
            messeges: {
                en:{
                    title: 'Success',
                    subtitle: 'Successful authorization',
                },
                ru:{
                    title: 'Успех',
                    subtitle: 'Успешная авторизация',
                }
            },
            login: null,
            password: '',
            submitted: false,
            showMessage: false,
            v$: useVuelidate(),
            messages: [],
            isLoading: false,
        }
    },
    validations() {
        return {
            login: {required},
            password: {required},
        }
    },
    watch: {
        login :function(login){
            this.login=login.toLowerCase()
        },
    },
    methods: {
        go_reg() {
            this.$router.push({ path: '/reg/' })
        },
        go_pass() {
            this.$router.push({ path: '/pass/' })
        },
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        ...mapActions(["ActionLogin"]),
        async handleSubmit(isFormValid) {
            this.isLoading = true
            this.submitted = true;

            if (!isFormValid) {
                this.isLoading = false
                return;
            }

            try {
                const login = await this.ActionLogin({login: this.login, password: this.password}).then(res=>res)
                if(login.result && login.data){
                    this.showMess('success', this.messeges[this.lang].title, this.messeges[this.lang].subtitle) 
                    this.resetForm()
                    this.isLoading = false

                  

                    // this.$router.push({ path: (this.redirect_url) ? this.redirect_url : '/'})
                } else {
                    this.isLoading = false
                    if(login.errors) {
                        for (let i = 0; i < login.errors.length; i++) {
                            this.showMess('error', 'Error', login.errors[i])
                        }
                    } else {
                        this.showMess('error', 'Error', 'Authorisation Error')
                    }
                }
            } catch (error) {
                console.log('error', error)
                this.showMess('error', 'Error', 'Authorisation Error')
                this.isLoading = false
            }
        },
        resetForm() {
            this.login = '';
            this.password = '';
            this.accept = null;
            this.submitted = false;
        }
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' }
    },
    beforeCreate(){
        this.connect = new Connect()
    },
    mounted() {
       
    }
}
</script>